import { getChangedDocumentsModuleData } from "config/changesDocumentData";
import { Field } from "formik";
import UploadChangedDocuments from "./FileUploadForm";

const ChangedDocuments = ({
  uploadRequestType = "",
  field,
  form,
  resolvedFields = [],
  documentsFor = "",
  openKey,
  setOpenKey = null,
  idType,
  designation,
  ...props
}) => {
  return (
    <div className="flex flex-col">
      {
        <div className="container bg-white mt-4 px-4 py-4 shadow-sm rounded-md">
          <Field
            name={"fileUploads"}
            component={UploadChangedDocuments}
            documentData={getChangedDocumentsModuleData(
              uploadRequestType === "Director Approval"
                ? "directorApprovalSignedDocuments"
                : uploadRequestType === "Shareholder Approval"
                ? "shareholderApprovalSignedDocuments"
                : uploadRequestType === "Gazette Notice"
                ? "gazetteApprovalSignedDocuments"
                : uploadRequestType === "Creditors Resolution"
                ? "creditorsApprovalSignedDocuments"
                : uploadRequestType === "Court Order"
                ? "courtOrderApprovalSignedDocuments"
                : uploadRequestType === "appointment-letter"
                ? "appointmentLetter"
                : uploadRequestType === "appointing-official"
                ? "appointingOfficialSignedDocuments"
                : "approvedChangesDocuments"
            )}
            disabled={false}
            idType={idType}
            designation={designation}
          />
        </div>
      }
    </div>
  );
};

export default ChangedDocuments;
